<template>
    <section class="sitemap-links">
        <div class="page-container">
            <ul class="sitemap-links-main-list">
                <li class="sitemap-links-main-list--1">
                    <ul>
                        <li>
                            <router-link to="/" class="main-link home">
                                Home
                            </router-link>
                        </li>

                        <li>
                            <h2>Why JORNAY PM</h2>

                            <ul>
                                <li
                                    v-for="(item, index) in whyJornay"
                                    :key="index"
                                >
                                    <router-link
                                        :to="item.path"
                                        class="internal-link"
                                        >{{ item.name }}</router-link
                                    >
                                </li>
                            </ul>
                        </li>

                        <li>
                            <router-link
                                to="/dosing"
                                class="main-link main-link--dosing"
                            >
                                Dosing
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li class="sitemap-links-main-list--2">
                    <ul>
                        <li>
                            <router-link to="/safety" class="main-link main-link--safety">
                                Safety
                            </router-link>
                        </li>

                        <li>
                            <h2>Savings & Resources</h2>

                            <ul >
                                <li
                                    class="pt-0"
                                    v-for="(item, index) in savings"
                                    :key="index"
                                >
                                    <router-link
                                        :to="item.path"
                                        class="internal-link"
                                        >{{ item.name }}</router-link
                                    >
                                </li>
                            </ul>
                        </li>

                        <li>
                            <router-link to="/sign-up" class="main-link main-link--signup">
                                Sign Up
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li class="sitemap-links-main-list--3">
                    <ul>
                        <li v-for="(item, index) in additionalTop" :key="index">
                            <router-link
                                v-if="item.type === 'internal'"
                                :to="item.path"
                                class=""
                                >{{ item.name }}</router-link
                            >

                            <a
                                v-if="item.type === 'external'"
                                :href="item.path"
                                target="_blank"
                                rel="noopener noreferrer"
                                >{{ item.name }}</a
                            >
                            <a
                                style="
                                    color: #30368c;
                                    font-weight: bold;
                                    text-decoration: underline;
                                    cursor: pointer;
                                "
                                v-if="item.type === 'ISI'"
                                @click="handleExternalLinkClick"
                                >{{ item.name }}</a
                            >
                            <img
                                v-if="item.type === 'external'"
                                src="@/assets/img/icon-Link.svg"
                                width="15"
                                height="15"
                                alt=""
                            />
                        </li>
                    </ul>

                    <ul>
                        <li
                            v-for="(item, index) in additionalBottom"
                            :key="index"
                        >
                            <a
                                v-if="item.type === 'external'"
                                :href="item.path"
                                target="_blank"
                                rel="noopener noreferrer"
                                >{{ item.name }}</a
                            >
                            <img
                                v-if="item.type === 'external'"
                                src="@/assets/img/icon-Link.svg"
                                width="15"
                                height="15"
                                alt=""
                            />
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            whyJornay: [
                { name: 'Efficacy', path: '/adhd-medication-efficacy' },
                {
                    name: 'PK/PD Model',
                    path: '/methylphenidate-dosage-duration',
                },
                { name: 'PK Profile', path: '/pk-data' },
            ],
            savings: [
                { name: 'Patient Savings', path: '/savings' },
                // { name: 'Find JORNAY PM', path: '/pk-data' },
                { name: 'Downloadable Resources', path: '/resources' },
                // { name: 'ADHD PeerSpectives', path: '/peerspectives' },
            ],
            additionalTop: [
                {
                    name: 'Visit Patient Site',
                    path: 'https://www.jornaypm.com/',
                    type: 'external',
                },
                {
                    name: 'Important Safety Information',
                    path: '',
                    type: 'ISI',
                },
                {
                    name: 'Full Prescribing Information',
                    path: 'https://www.collegiumpharma.com/wp-content/uploads/JORNAY_PM_Label.pdf',
                    type: 'external',
                },
                // {
                //     name: 'Pricing Information',
                //     path: '/Price_Disclosure',
                //     type: 'internal',
                // },
            ],
            additionalBottom: [
                {
                    name: 'Contact Us',
                    path: 'https://www.collegiumpharma.com/contact-us/',
                    type: 'external',
                },
                {
                    name: 'Terms of Use',
                    path: 'https://www.collegiumpharma.com/terms-of-use/',
                    type: 'external',
                },
                {
                    name: 'Privacy Policy',
                    path: 'https://www.collegiumpharma.com/privacy-policy/',
                    type: 'external',
                },
            ],
        };
    },
    methods: {
        handleExternalLinkClick() {
            this.$root.$emit('toggle-widget'); // Emit event globally
        },
    },
};
</script>
